import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import Dropzone from 'react-dropzone';
import { connect } from "react-redux";
import './index.scss';
import * as validator from './validator';
import { addDropzoneFiles } from '../actions/dlaactions'
import { toast } from 'react-toastify';
import * as constants from '../filestatus/dlaconstants'

class DropArea extends Component {
  constructor() {
    super();
    this.onDrop = (files) => {
      console.log(validator.helloWorld());
      const reader = new FileReader()

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onload = () => {
        const data = reader.result;
        let workbook = validator.getWorkBook(data);
        let errors = validator.validateSheetNames(workbook);
        if (errors.length>0) {
          toast.error("Worksheet(s) "+errors.toString()+" doesn't exist", {
            autoClose: false
          });
          return;
        }
        let errorsHeader = validator.validateBOMHeader(workbook);
        if (errorsHeader.length>0) {
          toast.error(errorsHeader+` in ${constants.LOGIC_BOM_HEADER_SHEET_NAME} worksheet`, {
            autoClose: false
          });
        }

        let errorsLineItem = validator.validateBomLineItemSheet(workbook);
        if (errorsLineItem.length>0) {
          toast.error(errorsLineItem, {
            autoClose: false
          });
        }
        
        if(errorsHeader===""&& errorsLineItem===""){
          this.props.addDropzoneFiles(files);
        }       
        
      }
      reader.readAsArrayBuffer(files[0]);      
    };

  }

  render () {
    return (
      <Dropzone onDrop={this.onDrop}>
        {({ getRootProps, getInputProps }) => (

          <div {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps({ id: 'upload-input' })} />
            <p>Drag & Drop or Click Here to queue files for import. Max file limit is {this.props.maxLimit} and Max row limit per file is {this.props.maxRowLimit}.</p>
          </div>

        )
        }

      </Dropzone>

    );
  }
}

const mapStateToProps = state => ({
  data: state.gCache.data
});

const mapDispatchToProps = dispatch => bindActionCreators({

  addDropzoneFiles

}, dispatch);
export default React.memo(connect(
  mapStateToProps,
  mapDispatchToProps
)(DropArea));





